import Cookies from "js-cookie";

const userExportAuthenticationConfig = () => {

  let type = "text/csv";

  if (Cookies.get("token") !== "") {
    return {
      headers: {
        "Content-Type": type,
        "Authorization": "Bearer " + Cookies.get("token"),
        "Accept": type
      }
    };
  }
  return {
    headers: {
      "Content-Type":type
    }
  };
};

export default userExportAuthenticationConfig;
